// add scroll-to hook for links with hash in href when the element is on same page
// https://stackoverflow.com/questions/7717527/jquery-smooth-scrolling-when-clicking-an-anchor-link
$(document).ready(function () {
	$('a[href*="#"]:not([href="#"])').click(function () {
		var target = $(this.hash);
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top
			}, 1000);
			return false;
		}
	});
});
